import { render } from "./QuizResultModal.vue?vue&type=template&id=e9900060"
import script from "./QuizResultModal.vue?vue&type=script&lang=js"
export * from "./QuizResultModal.vue?vue&type=script&lang=js"

import "./QuizResultModal.vue?vue&type=style&index=0&id=e9900060&lang=css"

import exportComponent from "/Users/priscillacancar/Documents/Coding/1) Engram-site/Engram/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__